import { defineModule } from '../types.js';
export default defineModule({
    id: 'noyau',
    nom: 'Noyau',
    description: 'Tableau de bord, session, exploitation (ingestion, journal), exports et administration des modules.',
    famille: 'noyau',
    dependances: [],
    activableParDefaut: true,
    desactivable: false,
    routesApi: [
        '/api/sante',
        '/api/configuration',
        '/api/session',
        '/api/deconnexion',
        '/api/tableau-de-bord',
        '/api/exports',
        '/api/modules',
        '/api/admin/modules',
        '/api/admin/journal',
        '/api/admin/ingestion',
    ],
    droits: {
        'noyau.consulter': { description: 'Consulter le tableau de bord', niveau: 'lecture' },
        'noyau.administrer': {
            description: 'Exploitation, réingestion et administration des modules',
            niveau: 'administration',
        },
    },
    navigation: [
        { cle: 'tableau-bord', libelle: 'Tableau de bord', picto: '◉', groupe: '', ordre: 0, droit: 'noyau.consulter' },
        { cle: 'exploitation', libelle: 'Exploitation', picto: '⚙', groupe: 'Administration', ordre: 100, droit: 'noyau.administrer' },
        { cle: 'modules', libelle: 'Modules', picto: '▦', groupe: 'Administration', ordre: 105, droit: 'noyau.administrer' },
    ],
});
//# sourceMappingURL=noyau.js.map